module.exports = __webpack_public_path__ + "img/logo-kiennast-full-white.1ced1493.png";